// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { subscribeApi } from "@steiner/App/Services/PipeAndWireSheetPricingServices";

type HandlerType = ApiHandlerDiscreteParameter<HasOnSuccess & HasOnError, ApiParameter, ServiceResult<void>>;

export const CallSubscribe: HandlerType = async props => {
    try {
        props.apiResult = await subscribeApi();
        props.apiResult.successful = true;
    } catch (error) {
        props.apiResult.successful = false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.();
    }
};

export const chain = [CallSubscribe, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const subscribeSheetPricing = createHandlerChainRunner(chain, "SubscribeSheetPricing");
export default subscribeSheetPricing;
